export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_18.c2a5fc45.jpg";